// extracted by mini-css-extract-plugin
export var collapsed = "DashboardLayout-module--collapsed--ypG0-";
export var container = "DashboardLayout-module--container--C8yb1";
export var main = "DashboardLayout-module--main--D9QTC";
export var mobile = "DashboardLayout-module--mobile--HOKdl";